@if (canEdit) {
    <button class="btn btn-raised" (click)="manageExecutionDetails()">
        <span>{{ 'executionDetailManager.manageExecutionButton' | t }}</span>
    </button>
}

<ng-template #spreadsheet>
    <div class="popup-instructions">
        <span>
            {{ 'executionDetailManager.instructionsIntro' | t }}
        </span>
        <ol>
            <li>
                <span>
                    {{ 'executionDetailManager.instructionDownload' | t }}
                </span>
            </li>
            <li>
                <span>{{ 'executionDetailManager.instructionOpen' | t }}</span><br />
                <span
                    ><b>{{ 'executionDetailManager.functionalitiesAvailable' | t }}</b></span
                >
                <ul>
                    <li>{{ 'executionDetailManager.functionalityFieldNames' | t }}</li>
                    <li>
                        {{ 'executionDetailManager.functionalityEmptyValue' | t }}
                    </li>
                </ul>
                <span
                    ><b>{{ 'executionDetailManager.limitationsApply' | t }}</b></span
                >
                <ul>
                    <li>
                        {{ 'executionDetailManager.limitationMappingColumns' | t }}
                    </li>
                    <li>
                        {{ 'executionDetailManager.limitationOrdering' | t }}
                    </li>
                    <li>
                        {{ 'executionDetailManager.limitationCharacterLimit' | t }}
                    </li>
                    <li>
                        {{ 'executionDetailManager.limitationOutdatedFile' | t }}
                    </li>
                </ul>
            </li>
            <li>
                <span>
                    {{ 'executionDetailManager.instructionUpload' | t }}
                </span>
            </li>
        </ol>
    </div>

    <div class="popup-buttons">
        <button class="btn btn-light" (click)="downloadExcel()">
            <i class="fas fa-download"></i>
            <span class="ms-2">{{ 'executionDetailManager.downloadButton' | t }}</span>
        </button>

        <input
            type="file"
            multiple="false"
            style="display: none"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            (change)="processExcel($event)"
            #fileInput
        />
        <button class="btn btn-light" (click)="fileInput.click()">
            <i class="fas fa-upload"></i>
            <span class="ms-2">{{ 'executionDetailManager.uploadButton' | t }}</span>
        </button>
    </div>
</ng-template>
